import PreguntaService from 'src/modules/pregunta/preguntaService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'PREGUNTA_FORM';

const preguntaFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: preguntaFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await PreguntaService.find(id);
      }

      dispatch({
        type: preguntaFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: preguntaFormActions.INIT_ERROR,
      });

      getHistory().push('/pregunta');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: preguntaFormActions.CREATE_STARTED,
      });

      await PreguntaService.create(values);

      dispatch({
        type: preguntaFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.pregunta.create.success'),
      );

      getHistory().push('/pregunta');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: preguntaFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: preguntaFormActions.UPDATE_STARTED,
      });

      await PreguntaService.update(id, values);

      dispatch({
        type: preguntaFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.pregunta.update.success'),
      );

      getHistory().push('/pregunta');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: preguntaFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default preguntaFormActions;
